export default "__VITE_ASSET__PfdBnysY__"